import * as React from "react";
import { utilRandom } from "../../../utils/utilRandom";
import { getRandomPercentage } from "./CrystalBallAnimation";
export var getRandomPosition = function () {
    var getRandomSize = utilRandom.getRandomNumberInRange(10, 20) + "px";
    return {
        height: getRandomSize,
        left: getRandomPercentage(),
        top: getRandomPercentage(),
        width: getRandomSize,
    };
};
export var CrystalBallStarsAnimation = React.memo(function () {
    var cubeFaces = ["front", "back", "right", "left"];
    return (React.createElement("div", { className: "cube" }, cubeFaces.map(function (value, index) { return (React.createElement("div", { className: "cube__face cube__face--" + value, key: index },
        React.createElement("div", { className: "star fortune-teller-event__star-particle", style: getRandomPosition() }),
        React.createElement("div", { className: "star fortune-teller-event__star-particle", style: getRandomPosition() }))); })));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/fortune-teller-event/components/CrystalBallStarsAnimation.tsx
// module id = 2838
// module chunks = 3